import { create } from 'zustand';

/**
 * Whether a newer frontend build is live, and whether we're still willing to
 * reload automatically to get it.
 *
 * Deliberately NOT registered with storeResetUtils: "a new build is available" is
 * a fact about the served bundle, not about the signed-in user, and it must
 * survive a logout — otherwise logging out would dismiss the update banner.
 */
interface VersionStore {
  /** A newer version is live. */
  updateAvailable: boolean;
  /** The version the server says we should be on. */
  latestVersion: string | null;
  /**
   * We already reloaded for this version and came back still stale, so reloading
   * again would just loop. The banner switches to a manual "Reload" and stops
   * counting down.
   */
  autoReloadBlocked: boolean;

  announceUpdate: (latestVersion: string, autoReloadBlocked: boolean) => void;
  dismiss: () => void;
}

const useVersionStore = create<VersionStore>((set) => ({
  updateAvailable: false,
  latestVersion: null,
  autoReloadBlocked: false,

  announceUpdate: (latestVersion, autoReloadBlocked) =>
    set({ updateAvailable: true, latestVersion, autoReloadBlocked }),

  dismiss: () => set({ updateAvailable: false })
}));

export default useVersionStore;
